import { Controller } from "@hotwired/stimulus"

// Hex text input + circular swatch preview. Clicking the swatch opens the
// native color picker (hidden input).
export default class extends Controller {
  static targets = ["hex", "swatch", "picker"]

  connect() {
    this.sync(this.hexTarget.value)
  }

  openPicker(event) {
    event.preventDefault()
    this.pickerTarget.click()
  }

  pickerChanged() {
    const value = this.pickerTarget.value
    this.hexTarget.value = value
    this.updateSwatch(value)
  }

  hexChanged() {
    const value = this.normalize(this.hexTarget.value)
    if (!value) return
    this.hexTarget.value = value
    this.pickerTarget.value = value
    this.updateSwatch(value)
  }

  sync(value) {
    const normalized = this.normalize(value) || value
    this.pickerTarget.value = normalized
    this.updateSwatch(normalized)
  }

  updateSwatch(value) {
    this.swatchTarget.style.backgroundColor = value
  }

  normalize(input) {
    if (!input) return null
    let value = input.trim()
    if (!value.startsWith("#")) value = `#${value}`
    return /^#[0-9a-fA-F]{6}$/.test(value) ? value.toLowerCase() : null
  }
}
